/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ActivityFeed_viewer$ref = any;
type Conversations_conversations$ref = any;
export type Notifications_viewer$ref = any;
export type Notifications_viewer = {
    readonly regInfo: ReadonlyArray<{
        readonly countryCode: string | null;
    } | null> | null;
    readonly isAutomatedOfferNotificationDisabled: boolean | null;
    readonly conversations?: {
        readonly " $fragmentRefs": Conversations_conversations$ref;
    } | null;
    readonly " $fragmentRefs": ActivityFeed_viewer$ref;
    readonly " $refType": Notifications_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "Notifications_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "LocalArgument",
            "name": "first",
            "type": "Int",
            "defaultValue": 5
        },
        {
            "kind": "LocalArgument",
            "name": "fetchNotifications",
            "type": "Boolean!",
            "defaultValue": false
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": "regInfo",
            "name": "regionalInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "RegionalInfo",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "countryCode",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "ScalarField",
            "alias": "isAutomatedOfferNotificationDisabled",
            "name": "isEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": "disableAutomatedOfferBellNotification"
                }
            ],
            "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchNotifications",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "conversations",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "showUnreadOnly"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        },
                        {
                            "kind": "Literal",
                            "name": "notifications",
                            "value": true
                        }
                    ],
                    "concreteType": "ConversationConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Conversations_conversations",
                            "args": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ActivityFeed_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'd9a3168ec5cb61b8c7b009531906dac6';
export default node;
